export default __webpack_public_path__ + "static/media/StaticMediaImage.b2589753.png";